import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import isEmpty from 'hs-lodash/isEmpty';
import { createRef } from 'react';
import { Flow } from 'signup-constants/Flow';
import { getIntegrationKey } from '../routing/getIntegrationKey';
import { isFlow } from '../utils/isFlow';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import { useTransitionAwareFocus } from '../hooks/useTransitionAwareFocus';
import { getIntegrationConfig } from '../integrations-flow/getIntegrationConfig';
import { Data } from '../signup-data/DATA';
import { SignupDataInput } from '../signup-data/SignupDataInput';
import { useNameFields } from './useNameFields';
import styled, { css } from 'styled-components';
import { devices } from '../styles/viewports.styles';
const firstNameAndLastNameSameLine = css(["display:flex;.SignupDataInput{flex:1;}> * + *{margin-left:1.25rem;}"]);
const NameFields = styled.div.withConfig({
  displayName: "UserInfoForm__NameFields",
  componentId: "sc-1jhfogf-0"
})(["@media ", "{", "}", ""], devices.desktop, firstNameAndLastNameSameLine, props => props.theme.embedded && firstNameAndLastNameSameLine);
export const UserInfoForm = ({
  className = ''
}) => {
  const {
    isEmbedded,
    autoFocusDisabled
  } = useSignupEmbedder();
  const shouldFocus = !(isEmbedded && autoFocusDisabled);
  const integrationKey = getIntegrationKey();
  const {
    nameFields,
    nameFieldRefs
  } = useNameFields(); // We need to include the email field ref here in case the user
  // is on a integration flow where the first and last name fields
  // are not displayed. This will make the email field be the one
  // auto focused on load.

  const emailInputRef = /*#__PURE__*/createRef();
  const inputRefs = [...nameFieldRefs, emailInputRef];
  useTransitionAwareFocus(inputRefs[0], shouldFocus);

  const renderNameFields = () => {
    if (isEmpty(nameFields)) {
      return null;
    }

    return /*#__PURE__*/_jsx(NameFields, {
      className: className,
      children: nameFields.map((key, index) => /*#__PURE__*/_jsx(SignupDataInput, {
        autoFocus: false,
        dataKey: key,
        ref: nameFieldRefs[index]
      }, key))
    });
  };

  const renderCompanyFields = () => {
    if (isFlow(Flow.Integrations) && integrationKey) {
      const integrationConfig = getIntegrationConfig(integrationKey);
      return integrationConfig.shouldAskCompanyInfoOnLandingPage && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(SignupDataInput, {
          autoFocus: false,
          dataKey: Data.CompanyName
        }, Data.CompanyName), /*#__PURE__*/_jsx(SignupDataInput, {
          autoFocus: false,
          dataKey: Data.CompanyDomain
        }, Data.CompanyDomain)]
      });
    }

    return null;
  };

  const renderEmailField = () => /*#__PURE__*/_jsx(SignupDataInput, {
    autoFocus: false,
    dataKey: Data.Email,
    ref: emailInputRef
  }, Data.Email);

  return /*#__PURE__*/_jsxs("div", {
    children: [renderNameFields(), renderEmailField(), renderCompanyFields()]
  });
};